import { render, staticRenderFns } from "./ImageAlbum.vue?vue&type=template&id=b21b744a&scoped=true&"
import script from "./ImageAlbum.vue?vue&type=script&lang=js&"
export * from "./ImageAlbum.vue?vue&type=script&lang=js&"
import style0 from "./ImageAlbum.vue?vue&type=style&index=0&id=b21b744a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b21b744a",
  null
  
)

export default component.exports